import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AngularFireModule } from 'angularfire2';

import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireStorageModule } from 'angularfire2/storage';


// Firebase setup instructions

// 1. delete this line, then...

// 2. Add your own firebase config to environment.ts
// 3. Then use it to initialize angularfire2 below, like so AngularFireModule.initializeApp(environment.firebaseConfig),


import { AuthService } from './auth.service';
import { AuthGuard } from './auth.guard';
import { PublicGuard } from './public.guard';

import { TokenInterceptor } from './token.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { environment } from "../../environments/environment";
import { EmailService } from './email.service';
import { DownloadService } from './download.service';
import { FontsBase64 } from './fonts.base64';

@NgModule({
    imports: [
        CommonModule,
        AngularFireModule.initializeApp(environment.firebase),
        AngularFirestoreModule,
        AngularFireAuthModule,
        AngularFireStorageModule
    ],
    declarations: [],
    providers: [
        AuthService,
        AuthGuard,
        PublicGuard,
        EmailService,
        DownloadService,
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        FontsBase64
    ]
})
export class CoreModule { }



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts